<header id="header" class="fixed-top user px-3 px-md-0 px-lg-0">
    <div class="container-fluid d-flex pr-md-4" id="header-container">
        <div class="logo">
            <a routerLink="/user/dashboard">
                <img src="../../../../assets/images/logos/takeabreath_logo-portfolio.png" class="d-none d-sm-none d-md-inline" id="header-logo-desktop">
                <img src="../../../../assets/images/logos/takeabreath_logo_only-portfolio.png" class="d-block d-sm-block d-md-none" id="header-logo-mobile">
            </a>
        </div>
        <!--
        <ul class="d-flex align-self-center ml-5 mb-0 list-unstyled mr-auto resource-links" *ngIf="user && showNavMenu">
            <li>
                <a [routerLink]="['/user/tips']" routerLinkActive="active">Breathing Tips</a>
            </li>
            <li>
                <a [routerLink]="['/user/resources/science']" routerLinkActive="active">Science</a>
            </li>
            <li>
                <a [routerLink]="['/user/resources/community']" routerLinkActive="active">Community</a>
            </li>
            <li>
                <a [routerLink]="['/user/resources/pods']" routerLinkActive="active">Breathe Pods</a>
            </li>
            <li>
                <a [routerLink]="['/user/resources/insights']" routerLinkActive="active">Quick Insights</a>
            </li>
        </ul>
        -->
        <nav class="nav-menu d-none d-block user-profile align-items-end ml-auto" *ngIf="user && showNavMenu">
            <ul class="d-flex justify-content-center align-items-center">
                <li class="d-none d-md-block d-sm-none mt-2 points">
                    <a routerLink="/user/profile" id="nav-divider" class="pr-3 pr-md-4">
                        <img class="badge-icon" src="../../../../assets/images/icons/award.svg">
                        <span class="d-inline-block align-middle ml-1 ml-md-1 mr-1 mr-md-1">{{ user?.points_earned + ' points' }}</span>
                    </a>
                </li>
                <li class="mt-2"><a routerLink="/user/profile" class="pl-3 pl-md-4 d-none d-sm-none d-md-block d-lg-block">Hi {{ user?.first_name }}</a></li>
                <li class="mt-2">
                    <a routerLink="/user/profile" class="user-icon">
                        <img [src]="user.avatar" class="rounded-circle avatar" *ngIf="user.avatar !== ''; else noAvatar" id="user-avatar-desktop">
                        <ng-template #noAvatar>
                            <img src="../../../../assets/images/avatars/default_profile.png" class="rounded-circle avatar" id="user-avatar-desktop-default">
                        </ng-template>
                    </a>
                </li>
            </ul>
        </nav>

    </div>
</header>
